import type { ReactNode } from "react"
import { useState } from "react"
import { CalendarLayoutContext } from "./useCalendarLayoutContext"

export const CalendarLayoutPrivider = (props: { children?: ReactNode }) => {
  const [selectedDate, setSelectedDate] = useState<Date>()

  return (
    <CalendarLayoutContext.Provider value={{ selectedDate, setSelectedDate }}>
      {props.children}
    </CalendarLayoutContext.Provider>
  )
}
